
import { ReactNode } from 'react';
import { interpolateSafe, interpolateWithReactStrategySafe, PhraseMap } from '@ms/yammer-i18n';

export default class InterpolateStrings {

  public static feature: string = 'navigation';

  private locale: string;
  private phrases: PhraseMap;

  constructor(locale: string, phrases: PhraseMap) {
    this.locale = locale;
    this.phrases = phrases;
  }

  public adminButtonAriaLabel(): string {
    return interpolateSafe(this.locale, this.phrases, 'adminButtonAriaLabel');
  }

  public appNavigationLabel(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationLabel');
  }

  public appNavigationFeed(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationFeed');
  }

  public appNavigationUserProfile(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationUserProfile');
  }

  public appNavigationInbox(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationInbox');
  }

  public appNavigationNotificationButtonAriaLabel(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationNotificationButtonAriaLabel');
  }

  public appNavigationMyAnalytics(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationMyAnalytics');
  }

  public appNavigationCommunities(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationCommunities');
  }

  public appNavigationHomeFeed(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationHomeFeed');
  }

  public appNavigationHome(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationHome');
  }

  public appNavigationAllFeed(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationAllFeed');
  }

  public appNavigationFirstRunStorylineUserProfileNewPill(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationFirstRunStorylineUserProfileNewPill');
  }

  public appNavigationQuestions(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationQuestions');
  }

  public appNavigationLeadershipCorner(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationLeadershipCorner');
  }

  public appNavigationStorylines(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationStorylines');
  }

  public appNavigationStorylineAllPostsAndStories(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationStorylineAllPostsAndStories');
  }

  public appNavigationFirstRunStorylineUserProfileNewPillAriaLabel(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationFirstRunStorylineUserProfileNewPillAriaLabel');
  }

  public appNavigationMoreActionsMenuButtonAriaLabel(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationMoreActionsMenuButtonAriaLabel');
  }

  public appNavigationInboxUnreadCount(args: { count: number }): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationInboxUnreadCount', args);
  }

  public appNavigationInboxTwentyPlusUnreadCount(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationInboxTwentyPlusUnreadCount');
  }

  public appNavigationNotificationsUnreadCount(args: { count: number }): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationNotificationsUnreadCount', args);
  }

  public appNavigationNotificationsTwentyPlusUnreadCount(): string {
    return interpolateSafe(this.locale, this.phrases, 'appNavigationNotificationsTwentyPlusUnreadCount');
  }

  public backButtonText(): string {
    return interpolateSafe(this.locale, this.phrases, 'backButtonText');
  }

  public favoritesLimitReachedTitle(): string {
    return interpolateSafe(this.locale, this.phrases, 'favoritesLimitReachedTitle');
  }

  public favoritesLimitReachedBody(): string {
    return interpolateSafe(this.locale, this.phrases, 'favoritesLimitReachedBody');
  }

  public favoritesLimitReachedCancel(): string {
    return interpolateSafe(this.locale, this.phrases, 'favoritesLimitReachedCancel');
  }

  public favoritesLimitReachedClose(): string {
    return interpolateSafe(this.locale, this.phrases, 'favoritesLimitReachedClose');
  }

  public loadingSpinnerText(): string {
    return interpolateSafe(this.locale, this.phrases, 'loadingSpinnerText');
  }

  public navigationCommunitiesThingsIManageHeading(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunitiesThingsIManageHeading');
  }

  public navigationCommunitiesHeading(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunitiesHeading');
  }

  public navigationCommunitiesHead(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunitiesHead');
  }

  public navigationCommunitiesHeadPanel(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunitiesHeadPanel');
  }

  public navigationCommunitiesFavorites(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunitiesFavorites');
  }

  public navigationCommunitiesNoItems(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunitiesNoItems');
  }

  public navigationCommunitiesNoFavoritesV2(args: { link: (str: string) => ReactNode }): ReactNode {
    return interpolateWithReactStrategySafe(this.locale, this.phrases, 'navigationCommunitiesNoFavoritesV2', args);
  }

  public navigationCommunitiesNoFavorites(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunitiesNoFavorites');
  }

  public navigationCommunitiesNoFavoritesVE(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunitiesNoFavoritesVE');
  }

  public navigationCommunitiesViewAll(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunitiesViewAll');
  }

  public navigationCommunitiesSeeMore(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunitiesSeeMore');
  }

  public navigationCommunitiesCreateLink(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunitiesCreateLink');
  }

  public navigationCommunitiesDiscoverLink(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunitiesDiscoverLink');
  }

  public navigationCommunitiesListRejectedErrorText(args: { link: (str: string) => ReactNode }): ReactNode {
    return interpolateWithReactStrategySafe(this.locale, this.phrases, 'navigationCommunitiesListRejectedErrorText', args);
  }

  public navigationCommunityUnreadCount(args: { count: number }): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunityUnreadCount', args);
  }

  public navigationCommunityTwentyPlusUnreadCount(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunityTwentyPlusUnreadCount');
  }

  public navigationCommunityOfficial(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunityOfficial');
  }

  public navigationCommunityFavorite(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunityFavorite');
  }

  public navigationCommunityLiveEvent(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunityLiveEvent');
  }

  public navigationCommunityIconAddToFavoritesToolTip(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunityIconAddToFavoritesToolTip');
  }

  public navigationCommunityIconRemoveFromFavoritesToolTip(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationCommunityIconRemoveFromFavoritesToolTip');
  }

  public navigationSpinnerLoadingText(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationSpinnerLoadingText');
  }

  public navigationSpinnerTimedOutText(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationSpinnerTimedOutText');
  }

  public navigationSpinnerError(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationSpinnerError');
  }

  public navigationSpinnerReload(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationSpinnerReload');
  }

  public navigationToPageTitle(): string {
    return interpolateSafe(this.locale, this.phrases, 'navigationToPageTitle');
  }

}
